import axios from 'axios';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import qs from 'query-string';
import qsFilters from  'qs';

// Libs
import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence } from '../../libs/utils';

// Constants
import { 
  CONTRACT_BASE, 
  CONTRACT_DETAIL, 
  CONTRACT_EXPORT, 
  CREATE_CONTRACT,
  PORTAL_CONTRACT, 
  CLIENT_RECURRING_PAYMENT, 
  CLIENT_CONFIRM_DOMICILIATION, 
  CONTRACT_RECURRING_PAYMENT, 
  CLIENT_RECURRING_PAYMENT_QUERY, 
  CONTRACT_IMPORT,
  CLIENT_CONTRACTS, 
  CONTRACT_FRECUENCY,
  CANCEL_CONTRACT } from '../../constants/endpoints';

export const NEW_CONTRACTS              = 'NEW_CONTRACTS';
export const NEW_SINGLE_CONTRACT        = 'NEW_SINGLE_CONTRACT';
export const NEW_EXPORT_CONTRACTS       = 'NEW_EXPORT_CONTRACTS';
export const NEW_SINGLE_CONTRACT_PORTAL = 'NEW_SINGLE_CONTRACT_PORTAL';
export const NEW_RECURRING_PAYMENT      = 'NEW_RECURRING_PAYMENT';
export const NEW_STRIPE_SESSION_ID      = 'NEW_STRIPE_SESSION_ID';
export const NEW_IMPORT_CONTRACTS       = 'NEW_IMPORT_CONTRACTS';
export const NEW_CONTRACTS_FILTERS      = 'NEW_CONTRACTS_FILTERS';
export const NEW_LOADING_TABLE          = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING              = 'NEW_SEARCHING';

function filterCatalog(n){
  switch(parseInt(n)){
    case 1:
      return `active`;

    case 2:
      return `inactive`;

    case 3:
      return `no_ended`;

  } // END switch

  return null;

}; // END filterCatalog

export function getContracts(params) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, identifier, customer, startDate, endDate, cancelToken } = params;

  if (activeTab) qsObj.status = filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (identifier) qsObj.identifier = identifier;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');

  } // END if

  return dispatch => axios.get(`${CONTRACT_BASE}?${qs.stringify(qsObj)}`,  cancelToken ? { cancelToken: cancelToken.token } : {})
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CONTRACTS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getInvoices

export function getContractsPortal(uuid, params) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { page, identifier } = params;

  if (page) qsObj.page = page;
  if (identifier) qsObj.identifier = identifier;

  return dispatch => axios.get(parseUrl(`${CLIENT_CONTRACTS}?${qs.stringify(qsObj)}`, { uuid }))
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_CONTRACTS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getInvoices

export function exportContracts(params = {}) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, identifier, customer, startDate, endDate } = params;

  if (activeTab) qsObj.filter = filterCatalog(params.activeTab);
  if (page) qsObj.page = params.page;
  if (identifier) qsObj.identifier = params.search;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    if (endDate) qsObj.end = endDate;
    else qsObj.end = moment().format('YYYY-MM-DD');

  } // END if

  return dispatch => axios.get(`${CONTRACT_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_CONTRACTS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));


} // END exportInvoices

export function getSingleContract(uuid) {
  return dispatch => axios.get(parseUrl(CONTRACT_DETAIL, { uuid }))
    .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_CONTRACT, 'ERROR'))
    // .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getSingleInvoice

export function getPortalContract(uuid, id) {
  return dispatch => axios.get(parseUrl(PORTAL_CONTRACT, { uuid, id }))
    .then(res => new Consequence({dispatch,
      payload: { data : get(res, 'data.data', {})},
      eventTypes: { success: NEW_SINGLE_CONTRACT_PORTAL, error: 'ERROR'}
    }))
} // END getPortalContract

export function createContract(payload) {
  return dispatch => axios.post(CREATE_CONTRACT, payload)
    .then(res => new Consequence({dispatch,
      payload: { data : get(res, 'data.data', {})},
      eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR'}
    }))
} // END createContract

/**
* Cancela contrato y actualiza estado de redux de detalle del contrato
* @param {Object} contract 
* @return 
*/
export function cancelContract(contract = {}) {
  const { uuid } = contract;
  
  return dispatch => axios.put(parseUrl(CANCEL_CONTRACT, { uuid }))
    .then(() => {
      const newContract = {
        ...contract,
        status: 'canceled'
      };

      return new Consequence({dispatch,
        payload: { data : newContract },
        eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR'}
      })
    })
}

export function requestRecurringPaymentAdmin(payload) {
  return dispatch => axios.post(CONTRACT_RECURRING_PAYMENT, payload)
    .then(res => new Consequence({dispatch,
      payload: { data : res},
      eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR'}
    }))

} // END CLIENT_RECURRING_PAYMENT

export function requestRecurringPaymentClient(uuid, payload) {
  return dispatch => axios.post(parseUrl(CLIENT_RECURRING_PAYMENT, { uuid }), payload)
    .then(res => new Consequence({dispatch,
      payload: { data : res},
      eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR'}
    }))

} // END CLIENT_RECURRING_PAYMENT

export function createStripeSessionRecurringPayment(uuid, payload) {
  return dispatch => axios.post(parseUrl(CLIENT_CONFIRM_DOMICILIATION, { uuid }), payload)
    .then(res => new Consequence({dispatch,
      payload: { data : get(res, 'data.data')},
      eventTypes: { success: NEW_STRIPE_SESSION_ID, error: 'ERROR'}
    }))

} // END CLIENT_RECURRING_PAYMENT

export function deleteRecurringPaymentContract(uuid, c) {
  return dispatch => axios.delete(parseUrl(CLIENT_RECURRING_PAYMENT_QUERY, { uuid }, { c }))
    .then(res => new Consequence({dispatch,
      payload: { data : res },
      eventTypes: { success: NEW_RECURRING_PAYMENT, error: 'ERROR'}
    }))

} // END CLIENT_RECURRING_PAYMENT

export function importContracts(payload) {
  return dispatch => axios.post(CONTRACT_IMPORT, payload, { headers: { 'content-type': 'multipart/form-data' } })
    .then(res => new Consequence({dispatch,
      payload: { data : res },
      eventTypes: { success: NEW_IMPORT_CONTRACTS, error: 'ERROR'}
    }))

} // END importContractXls

export function updateContractFrecuency(uuid, id, payload) {
  return dispatch => axios.put(parseUrl(CONTRACT_FRECUENCY, { uuid, id }), payload)
    .then(() => axios.get(parseUrl(CONTRACT_DETAIL, { uuid })))
    .then(res => new Consequence({dispatch,
      payload: { data : get(res, 'data.data', {})},
      eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR'}
    }))

} // END updateContractFrecuency

export function updateContractDetail(uuid, payload) {
  return dispatch => axios.put(parseUrl(CONTRACT_DETAIL, { uuid }), payload)
    .then(() => axios.get(parseUrl(CONTRACT_DETAIL, { uuid })))
    .then(res => new Consequence({dispatch,
      payload: { data : get(res, 'data.data', {})},
      eventTypes: { success: NEW_SINGLE_CONTRACT, error: 'ERROR'}
    }))

} // END updateContractFrecuency

export function getContractsVisibilityFilters(filters, updateTable = true, searching = true) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_CONTRACTS_FILTERS,
    payload: { filters, updateTable, searching }
  }));

} // END getContractsVisibilityFilters

export function updateLoadingTable(loadingTable) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_LOADING_TABLE,
    payload: loadingTable
  }));

} // END updateLoadingTable

export function getContractsV2(allFilters, cancelToken) {
  if (typeof allFilters !== "object" && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false }
  let url =`${CONTRACT_BASE}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(qsFilters.stringify(filters)).replace(/&/gi, '%26').split('-').join(''); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch => axios.get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
    .then(res => thunkHandler(dispatch, get(res, 'data.data'), NEW_CONTRACTS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));

} // END getContractsV2

export function newExportContracts(allFilters) {
  if (typeof allFilters !== "object" && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false }
  let url =`${CONTRACT_EXPORT}`;

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters =  String(qsFilters.stringify(filters)).replace(/&/gi, '%26'); // Library issue
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch => axios.get(url, { responseType: 'arraybuffer' })
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_CONTRACTS, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));


} // END exportInvoices

export function resetSearching() {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_SEARCHING,
    payload: false
  }));

} // END updateLoadingTable



// WEBPACK FOOTER //
// ./src/redux/actions/contractActions.js